module.exports = __webpack_public_path__ + "img/icon-stacking-looks-arrow.95de0b72.svg";